import React from 'react';
import { injectIntl, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { List, Map } from 'immutable';
import appConfig from '../../appConfig';
import PanelTree from '../PanelTree';
import NotificationBoxIcon from '../Icons/NotificationBox';
import WorkflowDashboardIcon from '../Icons/WorkflowDashboardDefault';
import { primaryTextColor } from '../../themes/index';
import {
  EDIT_HISTORY as EDIT_HISTORY_TYPE,
  DOWNLOAD_LIST as DOWNLOAD_LIST_TYPE,
} from '../../constants/mainContentTypes';
import { showEditHistoryAsMain } from '../../actions/mainUI';

const EDIT_HISTORY = 'editHistory';
const DOWNLOAD_LIST = 'downloadList';

function NavReportsPanel() {
  const intl = useIntl();
  const dispatch = useDispatch();
  let optionsList = new List();

  if (appConfig?.menuOptions?.reportsMenu?.length > 0) {
    const { reportsMenu } = appConfig.menuOptions;
    reportsMenu.forEach((value) => {
      switch (value) {
        case EDIT_HISTORY:
          optionsList = optionsList.push(new Map({
            i: EDIT_HISTORY,
            n: intl.formatMessage({ id: 'navReportsPanel.editHistory' }),
            icon: <NotificationBoxIcon stroke={primaryTextColor} style={{ margin: '0 6px' }} />,
          }));
          break;
        case DOWNLOAD_LIST:
          optionsList = optionsList.push(new Map({
            i: DOWNLOAD_LIST,
            n: intl.formatMessage({ id: 'navReportsPanel.downloadList' }),
            icon: <WorkflowDashboardIcon stroke={primaryTextColor} style={{ margin: '0 6px' }} />,
          }));
          break;
        default:
          break;
      }
    });
  }
  const onPanelItemClick = (key) => {
    switch (key) {
      case EDIT_HISTORY:
        dispatch(showEditHistoryAsMain(EDIT_HISTORY_TYPE));
        break;
      case DOWNLOAD_LIST:
        dispatch(showEditHistoryAsMain(DOWNLOAD_LIST_TYPE));
        break;
      default: break;
    }
  };

  return (
    <div className="nav-content__body">
      <h2 className="nav-content__title">{intl.formatMessage({ id: 'navReportsPanel.RecordHeader' })}</h2>
      <PanelTree
        onPanelItemClick={onPanelItemClick}
        panelTreeList={optionsList}
        isRoot
      />
    </div>
  );
}

export default injectIntl(NavReportsPanel);
